import { useEffect, useState } from 'react';
import ivclass from '@invideoio/web-shared/Modules/IVClass';

import { fetchAllCategories } from '@lib/API/categoryAPI';
import { CategoryType } from 'src/types';
import CategoryCard from '@components/categories/category-card';
import ShowMoreButton from '@components/showmore-button';
import { BrowserType, Pagination } from '@constants/common';
import Spinner from '@components/common/Spinner';
import { PlatformType } from '@invideoio/web-shared/constants/common';

type API_STATE = 'IDLE' | 'PENDING' | 'SUCESS' | 'FAILED';

interface PaginationType {
  browser: BrowserType;
  platform: PlatformType;
  totalCategories: number;
}
const CategoryPaginatedList = ({
  totalCategories,
  browser,
  platform,
}: PaginationType) => {
  const [categoryList, setCategoryList] = useState<CategoryType[]>([]);
  const [status, setStatus] = useState<API_STATE>('IDLE');

  async function loadMoreCategories() {
    setStatus('PENDING');
    const list = await fetchAllCategories({
      limit: Pagination.CATEGORIES_PER_PAGE,
      start: categoryList.length,
    });
    setCategoryList(categoryList => [...categoryList, ...list]);
    setStatus('SUCESS');
  }

  useEffect(() => {
    loadMoreCategories();
  }, []);

  return (
    <div className="iv-mb-100 md:iv-mb-80 sm:iv-mb-50">
      <div
        className={ivclass(
          'iv-grid iv-grid-cols-3 md:iv-grid-cols-2 sm:iv-grid-cols-1',
          'iv-col-span-12',
          'iv-gap-x-50 lg:iv-gap-x-40 md:iv-gap-x-[30px] ',
          'iv-gap-y-40 md:iv-gap-y-25 sm:iv-gap-y-20',
        )}
      >
        {categoryList?.map(category => (
          <div className="iv-mx-auto" key={category.id}>
            <CategoryCard platform={platform} browser={browser} {...category} />
          </div>
        ))}
        {status === 'PENDING' && (
          <div
            className={ivclass(
              'iv-col-span-3 md:iv-col-span-2 sm:iv-col-span-1',
              'iv-px-20 lg:iv-px-[0] md:iv-px-20',
              'iv-my-40 iv-mx-auto',
              'iv-h-32',
            )}
          >
            <div className="iv-mx-auto iv-text-center">
              <Spinner color="#3399ff" size={16} style={{ margin: '0 20px' }} />
              <span
                className={ivclass(
                  'iv-block',
                  'iv-my-15',
                  'iv-text-body-3xl iv-font-medium iv-text-grey-60',
                  'iv-whitespace-nowrap',
                )}
              >
                Fetching Categories
              </span>
            </div>
          </div>
        )}
      </div>
      {Array.isArray(categoryList) &&
        categoryList.length > 0 &&
        totalCategories !== categoryList.length && (
          <div className={ivclass('iv-mt-100 md:iv-mt-50 sm:iv-mt-30')}>
            <ShowMoreButton
              isPaginationEnded={totalCategories == categoryList.length}
              showMoreAction={loadMoreCategories}
            />
          </div>
        )}
    </div>
  );
};

export default CategoryPaginatedList;
